import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import { InboxPage } from '@/pages/inbox/InboxPage'

// Reuses the canonical Inbox page inside the Employee Center shell so the
// employee stays in the EC nav. Search schema mirrors the top-level /inbox
// route so deep-links survive validation.
const inboxSearchSchema = z.object({
  itemType: z.string().optional(),
  targetType: z.string().optional(),
  targetId: z.string().optional(),
  targetName: z.string().optional(),
  category: z.string().optional(),
  auditCycleId: z.string().optional(),
  commentId: z.string().optional(),
  tab: z.enum(['notifications', 'requests']).optional(),
})

function EmployeeInboxRoute() {
  // Employees see notifications only — no auditor Open Requests.
  return <InboxPage hideRequests />
}

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center/inbox',
)({
  component: EmployeeInboxRoute,
  validateSearch: inboxSearchSchema,
  staticData: { employeeCenterLayout: 'fullBleed' },
})
